import { BarChart3, CalendarDays, Send, Settings, Sun, Users, type LucideIcon } from 'lucide-react'

/*
 * The authenticated shell has exactly six primary destinations, in order.
 * There is no nested or expanding rail. Adding a seventh is an architectural
 * decision, not a feature launch.
 */
export type DestinationId =
  | 'today'
  | 'guests'
  | 'programme'
  | 'engagement'
  | 'insights'
  | 'setup'

export type Destination = {
  id: DestinationId
  labelKey: string
  icon: LucideIcon
  route: string
}

export const DESTINATIONS: Destination[] = [
  { id: 'today', labelKey: 'core.nav.today', icon: Sun, route: '/today' },
  { id: 'guests', labelKey: 'core.nav.guests', icon: Users, route: '/guests' },
  { id: 'programme', labelKey: 'core.nav.programme', icon: CalendarDays, route: '/programme' },
  { id: 'engagement', labelKey: 'core.nav.engagement', icon: Send, route: '/engagement' },
  { id: 'insights', labelKey: 'core.nav.insights', icon: BarChart3, route: '/insights' },
  { id: 'setup', labelKey: 'core.nav.setup', icon: Settings, route: '/setup' },
]
